<ng-container
  *ngIf="{
    emptyCart: emptyCart$ | async,
  } as content"
>
  <form [formGroup]="form" *ngIf="!content.emptyCart">
    <div class="form-group m-0">
      <simple-toggle [checked]="form.get('poLine')?.value" (callbackOnChange)="onChange($event)" label="cart.cartItems.poLine"></simple-toggle>
    </div>
  </form>
</ng-container>
